// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { type Flag } from '../model/flag';

export interface ProfileAvatarProps {
	userId: string;
	/** Avatar size */
	size?: AvatarSize;
	addFlag: (flag: Flag) => void;
	replace: (url: string) => void;
}
export interface InjectedQueryProps {
	hasUploadedAvatar?: boolean;
	/** Avatar image source */
	url?: string;
	/** Whether the avatar belongs to the current user */
	isCurrentUser?: boolean;
}

export const AVATAR_SIZES: {
	xsmall: number;
	small: number;
	medium: number;
	large: number;
	xlarge: number;
	xxlarge: number;
} = {
	xsmall: 8 * 2,
	small: 8 * 3,
	medium: 8 * 4,
	large: 8 * 5,
	xlarge: 8 * 12,
	xxlarge: 8 * 16,
};

export enum AvatarSize {
	xsmall = 'xsmall',
	small = 'small',
	medium = 'medium',
	large = 'large',
	xlarge = 'xlarge',
	xxlarge = 'xxlarge',
}

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AvatarWrapper = styled.div`
	position: relative;
	display: block;

	&& * {
		box-sizing: content-box;
	}

	&:hover,
	&:focus {
		outline: none;
	}
`;
